import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {required} from "@utility";
import {AbstractComponent} from "../abstract.component";
import {AddChipTime, EventItem, Lookups} from "@model";

@Component({
    selector: 'add-chip-time-modal',
    templateUrl: './add-chip-time-modal.component.html',
    styleUrls: ['./add-chip-time-modal.component.scss'],
    standalone: false
})
export class AddChipTimeModalComponent extends AbstractComponent implements OnInit {
  @Input() title: string | undefined;
  @Input() confirmButtonTitle: string | undefined;
  @Input() dismissButtonTitle: string | undefined;
  @Input() waypointIds: number[] = [];
  @Input() waypointLabels: string[] = [];
  @Input() raceListIds: number[] = [];
  @Input() raceListLabels: string[] = [];
  @Input() measurementsPointsView = true;
  @Input() event: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Output() onSave: EventEmitter<AddChipTime> = new EventEmitter<AddChipTime>();

  inputForm = new FormGroup({
    date: new FormControl(new Date()),
    chipTime: new FormControl(),
    raceId: new FormControl(),
    waypointId: new FormControl()
  });

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.inputForm.controls.chipTime.addValidators([required]);
    this.inputForm.controls.raceId.addValidators([required]);
    this.inputForm.controls.waypointId.addValidators([required]);
    this.inputForm.controls.waypointId.setValue(this.waypointIds[0]);
    this.inputForm.controls.raceId.setValue(this.raceListIds[0]);
    this.inputForm.updateValueAndValidity();
  }

  onConfirmClick(): void {
    this.onSave.emit({chipTime:this.inputForm.controls.chipTime.value, raceId:this.inputForm.controls.raceId.value,
      waypointId:this.inputForm.controls.waypointId.value === -1 ? undefined : this.inputForm.controls.waypointId.value, date: this.inputForm.controls.date.value} as AddChipTime);
    this.inputForm.controls.chipTime.setValue(undefined);
    this.inputForm.controls.chipTime.markAsUntouched();
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }
}
